import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { Funcionario } from 'src/app/core/funcionario';
import { TipoFuncionario } from 'src/app/core/tipo-funcionario';
import { FuncionarioService } from 'src/app/services/funcionario/funcionario.service';
import { ComboFuncionario } from '../../core/combo-funcionario';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-funcionario',
  templateUrl: './funcionario.component.html',
  styleUrls: ['./funcionario.component.css']
})
export class FuncionarioComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  funcionarios: Funcionario[];
  mostrarTabela: boolean = false;
  funcionario: Funcionario = new Funcionario();
  msg: string;
  ativo: boolean = true;
  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  tiposFuncionario: TipoFuncionario = new TipoFuncionario();

  displayedColumns: string[] = ['nome','matricula', 'dataAdmissao', 'tipoFuncionario', 'cargo', 'acoes'];
  dataSource: MatTableDataSource<Funcionario> = new MatTableDataSource();

  constructor(
    private funcionarioService: FuncionarioService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute

  ) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    this.dataSource.paginator = this.paginator;
    this.getAll();
  }


  limpar() {
    this.mostrarTabela = false;
    this.funcionario = new Funcionario()
    this.dataSource.data = [];
  }

  consultar() {
    if (this.funcionario.id) {
      this.funcionarioService.getById(this.funcionario.id).subscribe((funcionario: Funcionario) => {
        if (!Funcionario) {
          this.mostrarTabela = false
          this.msg = "Nenhum registro para a pesquisa selecionada"
        } else {
          this.dataSource.data = [funcionario];
          this.mostrarTabela = true;
        }
      })
    } else {
      this.getAll();
    }

  }

  atualizar(Funcionario: Funcionario) {
    this.router.navigate(['/funcionario/cadastrar'], { queryParams: { idFuncionario: Funcionario.id } });
  }

  deletar(Funcionario: Funcionario) {
    this.chamaCaixaDialogo(Funcionario);
  }

  chamaCaixaDialogo(funcionario: Funcionario) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Certeza que deseja excluir o Funcionario ?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.funcionarioService.excluir(funcionario.id).subscribe(() => {
          this.funcionario.id = null;
          this.consultar();
        })

      } else {
        dialogRef.close();
      }
    }
    );
  }

  onChangeCheckAtivo(event: any) {
    if (event) {
      this.ativo = event.checked;
    }
  }

  getAll() {
    this.funcionarioService.getAll().subscribe((funcionarios: Funcionario[]) => {
      const hoje = new Date();

      const funcionariosFiltrados = (funcionarios || []).filter(f => {
        const admissao = f.dataAdmissao ? new Date(f.dataAdmissao) : null;
        const demissao = f.dataDemissao ? new Date(f.dataDemissao) : null;
        const hojeEntreAdmissaoDemissao: boolean = (admissao && hoje >= admissao && (!demissao || hoje <= demissao));

        return !this.ativo || (this.ativo && hojeEntreAdmissaoDemissao);
      });

      const funcionariosOrdenados = funcionariosFiltrados.sort((a, b) => {
        const nomeA = a.pessoasFisica?.nome?.toLowerCase() || '';
        const nomeB = b.pessoasFisica?.nome?.toLowerCase() || '';
        return nomeA.localeCompare(nomeB);
      });

      this.funcionarios = funcionariosOrdenados;
      this.dataSource.data = funcionariosOrdenados;
      this.verificaMostrarTabela(funcionariosOrdenados);
    });
  }


  verificaMostrarTabela(funcionarios: Funcionario[]) {
    if (!funcionarios || funcionarios.length == 0) {
      this.mostrarTabela = false;
      this.msg = "Nenhum Funcionário cadastrado."
    } else {
      this.mostrarTabela = true;
    }
  }

  onValorChangeFuncionario(registro: ComboFuncionario) {
    if (registro && registro.id) {
        this.funcionarioService.getById(registro.id).subscribe((funcionario: Funcionario) => {
            this.funcionario = funcionario;
        })
    }
  }

  campoDesabilitado(): boolean {
      return !this.perfilAcesso.consulta;
  }
}
